<template>
  <div v-html="headerHTML"></div>
</template>

<script>
  import {getSource} from '../../plugins/header'

  export default {
    name: 'TheHeader',
    data() {
      return {
        headerHTML: ""
      };
    },
    async mounted() {
      await this.getHeader()
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.text = "$('#productsCategoriesBox').get(0).remove()"
      document.getElementsByTagName('body')[0].appendChild(script)
    },
    methods: {
      async getHeader() {
        const res = await getSource()
        let scriptReg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi
        let linkReg = /<link\s+[^>]*?href\s*=\s*["'][^"']*?["'][^>]*?>/gi
        this.headerHTML = res
          .replace(scriptReg, '')
          .replace(linkReg, '')
          .replace('<a                            href="https://www.ruijienetworks.com/login/">Log in</a>', '<a href="javascript:void(0);">Log in</a>');

        let scriptResult = res.match(scriptReg)
        let scriptList = []
        // 不想要的script src list
        let notWantScriptUrl = [
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/util.js',
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/ip.js?a=2',
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/jquery-1.10.2.min.js',
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/js/jquery.superslide.2.1.1.js',
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/new_navs/fer/fan/jquery.mCustomScrollbar.concat.min.js',
          'https://static.gridsumdissector.com/js/Clients/GWD-002990-C18B4B/gs.js',
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/res/UIB/Scripts/web-monitor-EN.js',
          'https://singapore-1312056779.cos.accelerate.myqcloud.com/site_style/Ruijie/search/search.js',
          'https://www.googletagmanager.com/gtag/js?id=G-GHFWZR42KW&cx=c&_slc=1',
          'https://www.google-analytics.com/analytics.js',
        ]
        // 不想要得要的link
        scriptResult && scriptResult.forEach((item, i) => {
          if (item.substring(0, 100).indexOf('src=') !== -1) {
            var reg3 = /<script.*?src="(.*?)".*?\/?>/i
            const url = item.match(reg3)[1]
            !notWantScriptUrl.includes(url) && scriptList.push(url)
          }
        });
        scriptList.forEach((text) => {
          if (!notWantScriptUrl.includes(text)) {
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = text
            document.getElementsByTagName('head')[0].appendChild(script)
          }
        })
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = '/static/header.js'
        document.getElementsByTagName('head')[0].appendChild(script)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/TheHeader.vue